import type { MentionComposeElement } from './useEmailMentionAssist';

/** Locates DevExtreme Chat's compose textarea inside the widget host. */
export function resolveChatComposeElement(host: HTMLElement | null): MentionComposeElement | null {
  if (!host) return null;
  const el = host.querySelector('.dx-chat-textarea textarea, .dx-chat textarea');
  if (el instanceof HTMLTextAreaElement) return el;
  if (el instanceof HTMLInputElement) return el;
  return null;
}
